<template>
  <AddPackage />
</template>
<script>
import appConfig from '@/app.config'
import AddPackage from '../../../components/dadban/packages/AddPackage.vue'
export default {
  page: {
    title: 'ثبت بسته',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-packages',
  components: {
    AddPackage,
  },
}
</script>
